import { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import useMonarchStore from './stores/monarchStore';
import type { DashboardSection } from './types/dashboard';
import Dashboard from './components/pages/Dashboard';
import Acquisition from './components/pages/Acquisition';
import Engagement from './components/pages/Engagement';
import Conversions from './components/pages/Conversions';
import Audience from './components/pages/Audience';
import Revenue from './components/pages/Revenue';
import WebsitePerformance from './components/pages/WebsitePerformance';
import { LoginPage } from './components/auth/LoginPage';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

/* ============================================================================
   Route <-> Section sync
   ============================================================================ */

const SECTION_ROUTES: Record<DashboardSection, string> = {
  overview:     '/overview',
  acquisition:  '/acquisition',
  engagement:   '/engagement',
  conversions:  '/conversions',
  audience:     '/audience',
  revenue:      '/revenue',
  website_performance: '/website-performance',
};

function SectionRouteSync() {
  const navigate = useNavigate();
  const activeSection = useMonarchStore((s) => s.ui.activeSection);

  useEffect(() => {
    const target = SECTION_ROUTES[activeSection];
    if (target && window.location.pathname !== target) {
      navigate(target, { replace: true });
    }
  }, [activeSection, navigate]);

  return null;
}

/* ============================================================================
   App
   ============================================================================ */

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <AppShell>
              <SectionRouteSync />
              <Routes>
                <Route path="/overview" element={<Dashboard />} />
                <Route path="/acquisition" element={<Acquisition />} />
                <Route path="/engagement" element={<Engagement />} />
                <Route path="/conversions" element={<Conversions />} />
                <Route path="/audience" element={<Audience />} />
                <Route path="/revenue" element={<Revenue />} />
                <Route path="/website-performance" element={<WebsitePerformance />} />
                <Route path="/" element={<Navigate to="/overview" replace />} />
                <Route path="*" element={<Navigate to="/overview" replace />} />
              </Routes>
            </AppShell>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
